<div class="container">
  <section class="navigation">
    @let key = appStateService.selectedLanguage.key;
    @let route = key === LngKeys.EN ? '/' : key;

    <a [routerLink]="'/' + route">
      <div class="logo"><h1>{{ title }}</h1></div>
    </a>


    @if (!shopping) {
      <span
        class="header-shopping-cart-wrapper"
        (click)="goToShoppingCartPage()">
        <i class="fas fa-shopping-cart header-shopping-cart"></i>
        <span>{{ shoppingService.shoppedTours.length }}</span>
      </span>
    }

    @if (shopping) {
      <span class="header-shopping-cart-wrapper location-back" (click)="location.back()">
        <i class="fas fa-undo-alt"></i>
      </span>
    }

    <div class="navigation-list">
      @if (!shopping) {
        @for (item of navBarItems; track item) {
          <div (click)="scrollTo(item.id)" class="navigation-list-item">
            <a>{{ item.name | translate }}</a>
          </div>
        }
      }

      <div style="width: 150px">
        <sf-dropdown
          [unSelectable]="false"
          [hasSearch]="false"
          [additionalClassName]="'lng-dropdown'"
          [selectedItem]="appStateService.selectedLanguage"
          [items]="appStateService.languages"
          (select$)="changeLanguage($event)"
        />
      </div>
    </div>

    <!-- Mobile -->
    @if (!shopping) {
      <div (click)="toggleBurger()" [class.active]="navBarState" class="humburger">
        <div class="humburger-cont">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    }

    <div class="navigation-overley">
      <div class="overley-list">
        @for (item of navBarItems; track item) {
          <div
            (click)="scrollTo(item.id); navBarState = false"
            class="overley-list-item">
            <a>{{ item.name | translate }}</a>
          </div>
        }
      </div>
    </div>

  </section>
</div>

